__turbopack_context__.v({
  "content": "fbvpzG_content",
  "root": "fbvpzG_root",
  "tag": "fbvpzG_tag",
  "tags": "fbvpzG_tags",
  "title": "fbvpzG_title",
});
